"use strict";

exports.__esModule = true;
exports.DataItemChartElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Metrics = require("../../../Catalogs/Metrics");
var _RealtimeChart = require("../../Charts/RealtimeChart");
var _Series = require("../../Charts/Series");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _SelectionContext = require("../../Core/SelectionContext");
var _DeviceContext = require("../../Device/DeviceContext");
var _getDeviceDataItems = require("../../Device/common/getDeviceDataItems");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _TimeContext = require("../../Time/TimeContext");
var _common = require("../common");
var _getDataItemLabel = require("./getDataItemLabel");
var _HistoricalDataItemChart = require("./HistoricalDataItemChart/HistoricalDataItemChart");
var _styles = require("./styles");
var _Feature = _interopRequireDefault(require("../../FeatureFlags/Feature/Feature"));
var _DataItemPopover = require("../common/DataItemPopover/DataItemPopover");
var _featureFlags = require("../../../featureFlags");
var _Env = require("../../Env");
var _TargetPopover = require("../common/TargetPopover/TargetPopover");
var _DeviceDataBatchSubscription = require("../../Device/DeviceDataBatchSubscription");
var _getYScaleCreator = _interopRequireDefault(require("./getYScaleCreator"));
var _constants = require("../../constants");
var _getRealTimeValuesFromBatchPacket = require("../../Charts/getRealTimeValuesFromBatchPacket");
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _DataItemChartElement;
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var comboChartPadding = 4;
var comboChartYAxisWidth = 45;

/**
 * Displays a particular MTC data item value for a device.
 */
var DataItemChartElement = exports.DataItemChartElement = (_dec = _SelectionContext.SelectionContext.withContext, _dec2 = _ConfigurableLayout.LayoutSettingsContext.withContext, _dec3 = _ReportingPeriod.ReportingPeriodContext.withContext, _dec4 = _TimeContext.TimeContext.withContext, _dec5 = _Env.EnvContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_DataItemChartElement = /*#__PURE__*/function (_Component) {
  function DataItemChartElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      mouseOverChart: false,
      xPosition: 0,
      mtcDataItemsValue: _this.props.mtcDataItems || [],
      target: null,
      isTargetOpen: false,
      isPopoverOpen: false
    };
    _this.registerContainer = function (container) {
      _this.container = container;
    };
    _this.handleMouseOver = function () {
      _this.setState({
        mouseOverChart: true
      });
    };
    _this.handleMouseMove = function (e) {
      if (_this.container) {
        var containerPosition = _this.container.getBoundingClientRect();
        var xPosition = e.clientX - (containerPosition.left + comboChartYAxisWidth + comboChartPadding);
        _this.setState({
          xPosition: xPosition
        });
      }
    };
    _this.handleMouseLeave = function () {
      _this.setState({
        mouseOverChart: false
      });
    };
    _this.renderRealTimeLegend = function (dataItems, defaultColor) {
      var legendContent = dataItems.map(function (dataItem) {
        var label = (0, _getDataItemLabel.getDataItemLabel)(dataItem);
        var color = dataItem != null && dataItem.color ? dataItem.color : defaultColor;
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: label,
          style: {
            display: "inline-block",
            marginRight: "10px"
          }
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          width: 14,
          height: 14,
          viewBox: "0 0 32 32",
          style: {
            display: "inline-block",
            verticalAlign: "middle",
            marginRight: "4px"
          }
        }, "//used similar path as in recharts legend used in HistoricalDataItemChart", /*#__PURE__*/_react["default"].createElement("path", {
          strokeWidth: "4",
          fill: "none",
          stroke: color,
          d: "M0,16h10.666666666666666 A5.333333333333333,5.333333333333333,0,1,1,21.333333333333332,16 H32M21.333333333333332,16 A5.333333333333333,5.333333333333333,0,1,1,10.666666666666666,16"
        })), /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            color: color,
            marginTop: "2px",
            display: "inline"
          }
        }, label));
      });
      return /*#__PURE__*/_react["default"].createElement("ul", {
        style: {
          padding: "0px",
          margin: "0px",
          textAlign: "center"
        }
      }, legendContent);
    };
    _this.renderRealtimeChart = function (device, dataItems, chartCurve) {
      var _this$props = _this.props,
        color = _this$props.color,
        width = _this$props.width,
        height = _this$props.height,
        hideXAxis = _this$props.hideXAxis,
        hideYAxis = _this$props.hideYAxis,
        hideLabel = _this$props.hideLabel,
        time = _this$props.time,
        showChartTooltip = _this$props.showChartTooltip,
        showLegend = _this$props.showLegend;
      var chartTitleHeight = !hideLabel && showLegend ? 24 : 0;
      var chartHeight = height - chartTitleHeight;
      var chartSeries = [];
      var itemsDict = {};
      var _loop = function _loop() {
        var di = dataItems[i];
        chartSeries.push({
          render: function render(props) {
            return /*#__PURE__*/_react["default"].createElement(_Series.LineChartSeries, _extends({}, props, {
              curve: chartCurve,
              color: di != null && di.color ? di.color : color,
              showChartTooltip: showChartTooltip
            }));
          }
        });
        itemsDict[device.uuid + "-" + di.name] = i;
      };
      for (var i = 0; i < dataItems.length; i++) {
        _loop();
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.EditButtonsContainer, null, _this.editTarget(), _this.editPopover(Object.assign({}, _this.props, {
        device: device,
        dataItems: dataItems,
        enableAddingNewItem: false
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "data-item-chart-realtime-test-id",
        ref: _this.registerContainer,
        onMouseOver: _this.handleMouseOver,
        onMouseMove: _this.handleMouseMove,
        onMouseLeave: _this.handleMouseLeave
      }, /*#__PURE__*/_react["default"].createElement(_DeviceDataBatchSubscription.DeviceDataItemBatchSubscription, {
        deviceUuid: device.uuid,
        dataItems: dataItems
      }, function (packet) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RealtimeChart.RealtimeChart, _extends({}, (0, _common.getWidgetInteractionProps)(_this.props), {
          width: width,
          height: chartHeight,
          yAxisWidth: comboChartYAxisWidth,
          createYScale: (0, _getYScaleCreator["default"])(dataItems, dataItems.length > 0 ? dataItems.every(function (di) {
            return di.units === dataItems[0].units;
          }) : false),
          latestValues: (0, _getRealTimeValuesFromBatchPacket.getRealTimeValuesFromBatchPacket)(packet, dataItems.length, itemsDict),
          units: dataItems[0].units || "",
          showXAxis: !hideXAxis,
          showYAxis: !hideYAxis,
          series: chartSeries,
          xTickFormat: function xTickFormat(value) {
            var val = (0, _momentTimezone["default"])(value).tz(time.timezone.name);
            return val.valueOf() % 60000 < 10000 ? val.format("hh:mm") : (0, _momentTimezone["default"])(value).tz(time.timezone.name).format(":ss");
          },
          referenceLineValue: parseFloat(_this.state.target) || 0,
          showReferenceLine: _this.state.target != null && _this.state.target.length > 0
        })), !hideLabel && showLegend && /*#__PURE__*/_react["default"].createElement(_styles.ChartTitle, {
          width: width,
          height: chartTitleHeight
        }, _this.renderRealTimeLegend(dataItems, color)));
      })));
    };
    _this.getSelectedHistoricalDataItems = function (historicalDataItems, initDataItems) {
      if (initDataItems === void 0) {
        initDataItems = [];
      }
      var _this$props$historica = _this.props.historicalDataItems,
        selectedDataItemIndices = _this$props$historica === void 0 ? [] : _this$props$historica;
      return selectedDataItemIndices.reduce(function (acc, _ref) {
        var dataItemIndex = _ref.dataItemIndex,
          color = _ref.color;
        if (historicalDataItems && historicalDataItems[dataItemIndex]) {
          return [].concat(acc, [Object.assign({}, historicalDataItems ? historicalDataItems[dataItemIndex] : {}, {
            color: color
          })]);
        }
        return acc;
      }, initDataItems);
    };
    _this.getSelectedMTCDataItems = function (deviceDataItems) {
      return deviceDataItems.reduce(function (dataItems, item) {
        var selectedMTCDataItem = _this.state.mtcDataItemsValue.find(function (mtcDataItem) {
          return mtcDataItem.dataItemName === item.name;
        });
        if (selectedMTCDataItem) {
          return [].concat(dataItems, [Object.assign({}, item, {
            color: selectedMTCDataItem.color
          })]);
        }
        return dataItems;
      }, []);
    };
    return _this;
  }
  _inheritsLoose(DataItemChartElement, _Component);
  var _proto = DataItemChartElement.prototype;
  _proto.editPopover = function editPopover(props) {
    var _this2 = this;
    var env = props.env,
      updateLayout = props.updateLayout,
      path = props.path,
      dataItemSource = props.dataItemSource,
      device = props.device,
      _props$dataItems = props.dataItems,
      dataItems = _props$dataItems === void 0 ? [] : _props$dataItems,
      enableAddingNewItem = props.enableAddingNewItem;
    var filteredMtcDataItems = this.filterMtcDataItemByDeviceDataItems(dataItems);
    var selectedDataItems = filteredMtcDataItems.length > 0 ? filteredMtcDataItems : dataItems == null ? void 0 : dataItems.map(function (_ref2) {
      var name = _ref2.name,
        color = _ref2.color;
      return {
        dataItemName: name,
        color: color
      };
    });
    return /*#__PURE__*/_react["default"].createElement(_Feature["default"], {
      name: _featureFlags.ENABLE_DATA_ITEM_EDIT,
      negative: false
    }, /*#__PURE__*/_react["default"].createElement(_DataItemPopover.DataItemPopover, {
      dataItems: selectedDataItems,
      isMultiSelector: true,
      allowedCategories: [_constants.CATEGORY_SAMPLE],
      onSubmit: function onSubmit(values) {
        if (env.featureFlags.includes(_featureFlags.ENABLE_DATA_ITEM_SAVE)) {
          updateLayout(path, "mtcDataItems", values);
        }
        _this2.setState({
          mtcDataItemsValue: values
        });
      },
      dataItemSource: dataItemSource,
      showButton: true,
      device: device,
      onOpen: function onOpen() {
        _this2.setState({
          isPopoverOpen: true
        });
      },
      onClose: function onClose() {
        _this2.setState({
          isPopoverOpen: false
        });
      },
      isOpen: this.state.isPopoverOpen,
      enableAddingNewItem: enableAddingNewItem
    }));
  };
  _proto.filterMtcDataItemByDeviceDataItems = function filterMtcDataItemByDeviceDataItems(deviceDataItems) {
    if (this.state.mtcDataItemsValue.length > 0) {
      return this.state.mtcDataItemsValue.filter(function (item) {
        return (deviceDataItems == null ? void 0 : deviceDataItems.map(function (dataItem) {
          return dataItem.name;
        }).indexOf(item.dataItemName)) > -1;
      });
    }
    return this.state.mtcDataItemsValue;
  };
  _proto.editTarget = function editTarget() {
    var _this3 = this;
    return /*#__PURE__*/_react["default"].createElement(_TargetPopover.TargetPopover, {
      targetValue: this.state.target || 0,
      showButton: true,
      onSubmit: function onSubmit(targetValue) {
        _this3.setState({
          target: targetValue.toString()
        });
      },
      onClose: function onClose() {
        return _this3.setState({
          isTargetOpen: false
        });
      },
      onOpen: function onOpen() {
        _this3.setState({
          isTargetOpen: true
        });
      },
      isOpen: this.state.isTargetOpen
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$props2 = this.props,
      layoutSettings = _this$props2.layoutSettings,
      dataItemSource = _this$props2.dataItemSource,
      dataItemIndex = _this$props2.dataItemIndex,
      time = _this$props2.time,
      reportingPeriod = _this$props2.reportingPeriod,
      dataRange = _this$props2.dataRange,
      selection = _this$props2.selection,
      _this$props2$chartCur = _this$props2.chartCurve,
      chartCurve = _this$props2$chartCur === void 0 ? "stepAfter" : _this$props2$chartCur;
    var selectedInterval = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
    var currentWorkday = time.currentWorkday,
      currentShift = time.currentShift;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "data-item-chart-element-testid"
    }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
      var _device$performancePa = device.performanceParameters,
        realtimeDataItems = _device$performancePa.realtimeDataItems,
        historicalDataItems = _device$performancePa.historicalDataItems;
      var dataItem,
        dataItems = _this4.getSelectedMTCDataItems((0, _getDeviceDataItems.getDeviceDataItems)(device));
      if (dataItemSource === "realtime" && dataItems.length === 0) {
        dataItem = realtimeDataItems[dataItemIndex];
      } else if (dataItemSource === "historical" && dataItems.length === 0) {
        dataItems = _this4.getSelectedHistoricalDataItems(historicalDataItems);
      }
      if (!dataItem && (!dataItems || dataItems.length === 0)) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.EditButtonsContainer, null, _this4.editPopover(Object.assign({}, _this4.props, {
          device: device
        }))), /*#__PURE__*/_react["default"].createElement("svg", _extends({}, (0, _common.getWidgetPositionProps)(_this4.props), (0, _common.getWidgetInteractionProps)(_this4.props))));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, layoutSettings.dataItemChart.realtime && (0, _Metrics.canSubscribeToRealtime)(currentWorkday.interval, currentShift.interval, selectedInterval) ? _this4.renderRealtimeChart(device, dataItem ? [dataItem] : dataItems, chartCurve) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.EditButtonsContainer, null, _this4.editTarget(), _this4.editPopover(Object.assign({}, _this4.props, {
        device: device,
        dataItems: dataItems
      }))), /*#__PURE__*/_react["default"].createElement(_HistoricalDataItemChart.HistoricalDataItemChart, _extends({}, _this4.props, {
        dataItems: dataItems,
        selectedInterval: selectedInterval,
        referenceLineValue: parseFloat(_this4.state.target),
        showReferenceLine: _this4.state.target != null && _this4.state.target.length > 0
      }))));
    }));
  };
  return DataItemChartElement;
}(_react.Component), _DataItemChartElement.defaultProps = {
  color: "#1678c2",
  selection: undefined,
  reportingPeriod: undefined,
  layoutSettings: undefined,
  time: undefined
}, _DataItemChartElement)) || _class) || _class) || _class) || _class) || _class);